export enum ApiCalls {
  None,
  HotelReservation,
  HotelInformation,
  ResDirect,
  Rate
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/enums/api-calls.enum.ts